import React, { useEffect, useRef, useState } from "react";

/**
 * Popup mở khi rê chuột / focus bàn phím, đóng khi rời chuột, Esc hoặc bấm ra ngoài.
 * Thay antd Dropdown ở header: header nằm trong JS chính của MỌI trang, dùng antd ở đây kéo cả
 * Menu/Trigger/Motion (~100KB) vào JS chính → chậm tải (PageSpeed).
 * open/onOpenChange: tùy chọn, để điều khiển từ ngoài (vd. giỏ mini đóng khi bấm link).
 */
const HoverPopover = ({ children, content, align = "right", open: openProp, onOpenChange, className = "" }) => {
  const [openState, setOpenState] = useState(false);
  const open = openProp ?? openState;
  const ref = useRef(null);
  const timer = useRef(null);

  const setOpen = (v) => {
    if (openProp === undefined) setOpenState(v);
    onOpenChange?.(v);
  };
  const show = () => {
    clearTimeout(timer.current);
    if (!open) setOpen(true);
  };
  const hide = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setOpen(false), 120);
  };

  useEffect(() => () => clearTimeout(timer.current), []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const onDown = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onDown);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("pointerdown", onDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div
      ref={ref}
      className={`relative ${className}`}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={(e) => !ref.current?.contains(e.relatedTarget) && hide()}
    >
      {children}
      {open && <div className={`absolute top-full z-[800] pt-2 ${align === "left" ? "left-0" : "right-0"}`}>{content}</div>}
    </div>
  );
};

export default HoverPopover;
